import type { ReactNode } from 'react';
import { Group, Stack, Title } from '@mantine/core';

/**
 * Каркас страницы-реестра: заголовок раздела, действие и фильтры закреплены,
 * прокручивается только сам список документов.
 *
 * Реестры счетов, УПД и актов длинные — при обычной прокрутке страницы вместе
 * со списком уезжали заголовок, кнопка создания и строка поиска, и чтобы
 * сменить фильтр приходилось возвращаться в начало. Здесь шапка раздела
 * зафиксирована, а область прокрутки ограничена таблицей.
 */
export function RegistryPage({
  title,
  action,
  description,
  filters,
  aside,
  children,
}: {
  title: string;
  /** Основное действие раздела — «Создать счёт» и т.п. */
  action?: ReactNode;
  /** Пояснение к разделу; остаётся в закреплённой части. */
  description?: ReactNode;
  /** Поиск и фильтры — всегда под рукой, не уезжают вместе со списком. */
  filters?: ReactNode;
  /** Боковая колонка раздела (дерево групп) — прокручивается отдельно от списка. */
  aside?: ReactNode;
  /**
   * Прокручиваемое содержимое: таблица реестра. Сюда же попадают Drawer и
   * Modal — Mantine рендерит их через портал в body, поэтому область
   * прокрутки их не обрезает.
   */
  children: ReactNode;
}) {
  return (
    <div className="erp-registry">
      <Stack gap="sm" className="erp-registry__head">
        <Group justify="space-between" wrap="nowrap" gap="sm">
          <Title order={2}>{title}</Title>
          {action}
        </Group>
        {description}
        {filters}
      </Stack>

      <div className="erp-registry__body">
        {aside && <div className="erp-registry__aside">{aside}</div>}
        <div className="erp-registry__scroll">{children}</div>
      </div>
    </div>
  );
}
